import React from 'react';
import simboloVita from '../assets/simboloVitaResize.png';
import { Button } from 'evergreen-ui';
import { useNavigate } from 'react-router-dom';

const AccessDeniedPage = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        height: '100vh',
        justifyContent: 'center',
        padding: '0 35px',
        gap: '40px',
      }}
    >
      <img src={simboloVita} alt='' width={250} />
      <h3>Você não possui permissão para acessar esta página.</h3>
      <Button onClick={() => navigate('/empresas')}>Ir para empresas</Button>
    </div>
  );
};

export default AccessDeniedPage;
